import React, { useEffect, useRef, useState } from "react";
import { Camera } from "lucide-react";
import { ACCEPT_ATTR, validateImageFile } from "../utils/aadhaarHelpers";

const AadhaarImageBox = ({
  title,
  hint,
  file,
  onChange,
  disabled,
  externalError = "",
}) => {
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!file) return setPreviewUrl("");
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const handleSelect = (e) => {
    const selected = e.target.files?.[0];
    e.target.value = "";
    if (!selected) return;
    const err = validateImageFile(selected);
    setError(err);
    if (!err) onChange(selected);
  };

  const shownError = error || externalError;

  return (
    <div className="w-full">
      <h2 className="text-center text-base font-medium text-black px-1 mb-3">
        {title}
      </h2>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT_ATTR}
        onChange={handleSelect}
        className="hidden"
      />
      <button
        type="button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className={`w-full h-32 rounded-xl border-2 border-dashed overflow-hidden flex flex-col items-center justify-center gap-1 transition ${
          shownError
            ? "border-red-400 bg-red-50"
            : "border-[#4a74b8] bg-[#f4f6fb]"
        } ${disabled ? "cursor-default" : "active:scale-[0.99]"}`}
      >
        {previewUrl ? (
          <img
            src={previewUrl}
            alt={title}
            className="h-full w-full object-contain"
          />
        ) : (
          <>
            <Camera className="h-8 w-8 text-[#3d6aa8]" strokeWidth={1.6} />
            <span className="mt-1 text-sm font-semibold text-[#3d6aa8]">
              Tap to upload Image
            </span>
            <span className="text-xs text-slate-500">{hint}</span>
          </>
        )}
      </button>
      {shownError && (
        <p className="text-red-600 text-sm mt-2 text-center">⚠️ {shownError}</p>
      )}
    </div>
  );
};

export default AadhaarImageBox;